import http from "@/shared/services/http";

export const createComplaintCustomer = (data: any) => http.post(`v1/customer/complaints`, data);
export const listComplaintCustomer = (params: any) => http.get(`v1/customer/complaints`, { params });
export const singleComplaintCustomer = (id: any) => http.get(`v1/customer/complaints/${id}`);